import { Component, inject } from '@angular/core';
import { ObrazacUnosaService } from '@app/components/fast-data-entry/service/obrazac-unosa.service';
import {
  ActionResult,
  ItemActionResult,
  NtapGlobalConstants,
  Util
} from '@ntap/core';
import { PrimeNGButtonDeleteItemActionComponent } from '@ntap/primeng';
import { first, map, mergeMap, Observable, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-delete-obrazac-upisa-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class DeleteObrazacUpisaActionComponent extends PrimeNGButtonDeleteItemActionComponent {
  private obrazacService = inject(ObrazacUnosaService);

  protected override doChangedInputParam(): void {
    super.doChangedInputParam();
    this.initDisabledObservable(); // ne znam zasto ovo treba zvati zasebno, ali inace se ne updejta state
  }

  protected override doExecute(): Observable<ActionResult> {
    //this.itemProvider.refresh(); ovo preskacemo jer ne zelimo validaciju forme
    return this.itemProvider.item$.pipe(
      mergeMap((item) => {
        return this.doExecuteWithItem(item).pipe(
          tap((result) => {
            this.updateItem(result);
            this.itemProvider.refresh();
          }), // na kraju ipak treba refresh inace sljedeci subscription vise ne radi ?
          map((result) => result.result)
        );
      }),
      first() // ItemAction should process only 1 item
    );
  }

  protected override doExecuteWithItem(
    item: any
  ): Observable<ItemActionResult> {
    return this.dataSource.executeAction(this.action.name, item).pipe(
      switchMap(() =>
        this.obrazacService.refetchEntryTemplateOptionsAndSelectFirstTemplate()
      ),
      map(
        () =>
          new ItemActionResult(
            {
              [Util.getFullAttrName(
                'obrazac_unosa',
                NtapGlobalConstants.ATTR_id
              )]:
                item[
                  Util.getFullAttrName(
                    'obrazac_unosa',
                    NtapGlobalConstants.ATTR_id
                  )
                ]
            },
            item
          )
      )
    );
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.action$.pipe(map((a) => a.disabled));
  }
}
